import React from "react";

import { Col, Row } from "react-bootstrap";


export const ProvincialHeader = ({ provName, imgBase64 }) => {

  const imgStyle = {
    width: "100%",        // Make image fill the container
    height: "100%",       // Make image fill the container
    objectFit: 'contain',   // Ensures the image covers the container without distorting aspect ratio
    borderRadius: "5px",   
  };


    return (
        <Row>
          <Col xl={3} sm={12} className="d-flex justify-content-center align-items-start">
            <div style={{width:'195px', height:'130px'}}>
              <img
                alt="prov-logo"
                src={imgBase64}
                style={imgStyle}
              />
              </div>
          </Col>
          <Col xl={9} sm={12} >
            <h3 className="pt-5"> Government Services in {provName} </h3> 
            <h4 className="text-muted"> {provName} </h4>
            <h4> Services available </h4>
          </Col>
        </Row>
    );
};